import type { Stock } from "@stockline/shared/types/inventory/stock"
import type { OfflineResourceConfig } from "../../../types"
import { STOCK_TABLE } from "./db"

export const stockConfig: OfflineResourceConfig<Stock> = {
  name: "stocks",
  syncDisabled: false,
  endpoints: {
    full: "/api/v2/stocks",
    delta: "/api/v2/stocks/changes",
    push: "/api/v2/stocks/changes",
  },
  tableName: STOCK_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    productId: "productId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
